<script>
import { mapGetters } from 'vuex'
import ConfirmationResendButton from '@/components/profile/ConfirmationResendButton.vue'
export default {
  components: {
    ConfirmationResendButton
  },
  data: () => ({
    dialog: true
  }),
  computed: {
    ...mapGetters(['locale'])
  },
  methods: {
    closeDialog() {
      this.dialog = false
      this.$router.push({ name: 'login', params: { locale: this.locale } })
    }
  }
}
</script>
<template>
  <v-dialog v-model="dialog" max-width="500">
    <v-card>
      <DialogBaseColoredTitle color="primary">{{
          $t('component.profile.accountManagement.thank.you') }}</DialogBaseColoredTitle>
      <DialogBaseCloseIcon color="white" @click="closeDialog" />
      <v-divider></v-divider>
      <DialogBaseText class="text-center primary--text">
        <v-row>
          <v-col> {{ $t('component.profile.accountManagement.almost.done') }} </v-col>
        </v-row>
      </DialogBaseText>
      <DialogBaseText class="text-center primary--text">
        <v-row>
          <v-col> {{ $t('component.profile.accountManagement.confirm.email') }} </v-col>
        </v-row>
        <ConfirmationResendButton :email="$route.params.email" />
      </DialogBaseText>
      <DialogBaseText class="text-center">
        <v-row>
          <v-col> {{ $t('component.profile.accountManagement.check.spam') }} </v-col>
        </v-row>
        <v-divider></v-divider>
      </DialogBaseText>
      <DialogBaseActions>
        <v-btn
          color="primary"
          class="white--text text-capitalize px-8 py-2"
          @click="closeDialog">
          <span>{{ $t('button.close') }}</span></v-btn>
      </DialogBaseActions>
    </v-card>
  </v-dialog>
</template>
